import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined);

  useEffect(() => {
    const token = localStorage.getItem("apha_token");
    if (!token) {
      setUser(null);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => {
        localStorage.removeItem("apha_token");
        setUser(null);
      });
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("apha_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const applySession = (token, nextUser) => {
    if (token) localStorage.setItem("apha_token", token);
    setUser((prev) => ({ ...(prev || {}), ...(nextUser || {}) }));
  };

  const logout = () => {
    api.post("/auth/logout").catch(() => {});
    localStorage.removeItem("apha_token");
    setUser(null);
  };

  return <AuthContext.Provider value={{ user, login, logout, applySession }}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  return useContext(AuthContext);
}

export function defaultRoute(role) {
  switch (role) {
    case "TEAM_MEMBER":
      return "/my-daily";
    case "PM":
    case "ADMIN":
      return "/action-center";
    case "LEAD":
      return "/team-workload";
    default:
      return "/portfolio";
  }
}
